import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthenticationFacade } from '@planone/bau365/data-access-authentication';
import { createBusinessCardSuccess, resetBusinessCardSuccess } from '@planone/bau365/data-access-user';
import * as FeatureTrackingGoogleAnalytics from '@planone/shared/feature-tracking-google-analytics';
import * as FeatureTrackingSnowplow from '@planone/shared/feature-tracking-snowplow';
import { map, of, switchMap, withLatestFrom } from 'rxjs';

import { generateBusinessCard } from './generate-business-card.actions';

import { CustomEventIglu } from '../../tracking-types/snowplow/schema/schema.interface';

@Injectable()
export class GenerateBusinessCardEffects {
  createNewBusinessCard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createBusinessCardSuccess),
      map(() => generateBusinessCard({ method: 'CREATE' }))
    )
  );

  updateNewBusinessCard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(resetBusinessCardSuccess),
      map(() => generateBusinessCard({ method: 'UPDATE' }))
    )
  );

  generateBusinessCard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(generateBusinessCard),
      withLatestFrom(this.authenticationFacade.excludeAnalytics$),
      switchMap(([{ method }, exclude_analytics]) =>
        of(
          FeatureTrackingGoogleAnalytics.push({
            event: 'generate_business_card',
            context: 'cross-fair',
            page_type: method === 'CREATE' ? 'profile' : 'profile/business-card',
            exclude_analytics,
            method,
          }),
          FeatureTrackingSnowplow.selfDescribingEvent({
            event: {
              schema: CustomEventIglu.generate_business_card,
              data: {
                context: 'cross-fair',
                page_type: method === 'CREATE' ? 'profile' : 'profile/business-card',
                exclude_analytics,
                method,
              },
            },
          })
        )
      )
    )
  );

  constructor(private readonly actions$: Actions, private authenticationFacade: AuthenticationFacade) {}
}
